/**
 * Convert a list of ID references for `aria-` attributes to an attribute value
 */
export const idListAttr = (...tokens: any[]): string | undefined =>
  tokens.filter(Boolean).join(' ').trim() || undefined;
